import { useMemo } from 'react';
import { useRecoilState } from 'recoil';
import {
  workspaceDashboardsState,
  workspaceState
} from "../../store/workspaceAtoms";

const useWorkspaceContext = () => {
  const [workspace, setWorkspace] = useRecoilState(workspaceState);
  const [workspaceDashboards, setWorkspaceDashboards] = useRecoilState(workspaceDashboardsState);

  const context = useMemo(() => ({
    workspace,
    workspaceDashboards,
    setWorkspace,
    setWorkspaceDashboards,
  }), [
    workspace,
    workspaceDashboards,
    setWorkspace,
    setWorkspaceDashboards,
  ]);

  return context;
};

export default useWorkspaceContext;